<template>
    <div class="table-wrap" v-if="tableData?.length">
        <table class="table table--default">
            <thead class="table__head">
            <tr class="table__row">
                <td class="table__col">№ тендера</td>
                <td class="table__col">Тип закупки</td>
                <td class="table__col">Наименование тендера</td>
                <td class="table__col">Товаров в&nbsp;тендере</td>
                <td class="table__col">Начало торгов</td>
                <td class="table__col">Окончание торгов</td>
                <td class="table__col">Место доставки</td>
                <td class="table__col">До завершения</td>
                <td class="table__col">Статус</td>
                <td class="table__col"></td>
            </tr>
            <tr class="table__margin">
                <td colspan="100%"></td>
            </tr>
            </thead>
            <tbody class="table__body">
                <SupplyTendersRow v-for="item in tableData" :key="item.id" :item="item"/>
            </tbody>
        </table>
    </div>
    <div v-else class="table-card__empty">Тендеры не найдены</div>
</template>

<script>
import SupplyTendersRow from "@/components/sections/LcSupply/SupplyTenders/SupplyTendersRow.vue";


export default {
    name: "SupplyTendersTable",
    components: {SupplyTendersRow},
    emits: ['changePage'],
    props: {
        tableData: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            currentPage: 1,
        }
    },
}
</script>


